import React, { useEffect, useState } from "react";
import axios from "axios";

import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeftCircle,
  ArrowRightCircle,
  Search,
  Star,
  StarFill,
  StarHalf,
} from "react-bootstrap-icons";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";

import "./Home.css";

// [imports remain unchanged]

export default function SearchClubs() {
  const [isloading, setIsLoading] = useState(true);
  const [clubs, setClubs] = useState([]);
  const [myClubs, setMyClubs] = useState([]);
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();

  const [next, setNext] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(24);
  const [name, setName] = useState();




  const fetchData = async () => {
    setIsLoading(true);
    let skipLogic = skip + skip;
    if (skip == 0) skipLogic = take;

    let url = `${ApiConnectionString}/api/clubs?Skip=${skip}&Take=${take}`;
    let nextUrl = `${ApiConnectionString}/api/clubs?Skip=${skipLogic}&Take=${take}`;

    if (name) {
      url += `&Name=${name}`;
      nextUrl += `&Name=${name}`;
    }

    try {
      let headers = user ? { Authorization: `bearer ${user.token}` } : {};

      const [clubsRes, nextRes] = await Promise.all([
        axios.get(url, { headers }),
        axios.get(nextUrl, { headers }),
      ]);

      let fetchedClubs = clubsRes.data;
      let myFetchedClubs = [];

      if (user) {
        const myClubsRes = await axios.get(
          `${ApiConnectionString}/api/Clubs/homepage`,
          { headers: { Authorization: `Bearer ${user.token}` } }
        );
        if (myClubsRes.status === 200) {
          myFetchedClubs = myClubsRes.data.map((club) => ({
            ...club,
            isMember: true,
          }));
        }
      }

      // Mark all clubs as not member
      fetchedClubs = fetchedClubs.map((club) => ({
        ...club,
        isMember: false,
      }));

      // Remove duplicates from fetchedClubs
      const filteredClubs = fetchedClubs.filter(
        (club) => !myFetchedClubs.some((myClub) => myClub.id === club.id)
      );

      // Combine and sort
      const combined = [...myFetchedClubs, ...filteredClubs];
      setClubs(combined);
      setMyClubs(myFetchedClubs); // still store in case needed
      setNext(nextRes.data);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, [skip, take, user]);

  const handleNext = (e) => {
    e.preventDefault();
    if (parseInt(clubs.length) >= parseInt(take)) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setSkip(parseInt(skip) + parseInt(take));
    }
  };

  const handlePrev = (e) => {
    e.preventDefault();
    if (skip != 0) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setSkip(parseInt(skip) - parseInt(take));
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    setSkip(0);
    setTake(24);
    setName("");
  };

  const renderClubCard = (club) => {
    const { starsAverage = 0, starsCount = 0 } = club;
    const fullStars = Math.floor(starsAverage);
    const hasHalfStar = starsAverage % 1 !== 0;
    const totalReviews = starsCount;

    return (
<div
  key={club.id}
  onClick={() => navi(`/club/${club.id}`)}
  className="search-club-container my-3 d-flex flex-column justify-content-between text-center position-relative"
>
  {club.isMember && (
    <div className="member-ribbon">
      <span>★ MEMBER</span>
    </div>
  )}

  <div>
    <div className="d-flex justify-content-center">
      <div className="search-circle-crop mt-3">
        <img
          src={
            club.hasImage
              ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
              : NoImagePlaceholder
          }
          alt="Club"
        />
      </div>
    </div>
    <div className="text-center">
      <p className="fontSize20 mt-2 mb-0 fw-bold">{club.name}</p>
      <p className="fw-bold mb-0">
        {club.city}, {club.county}
      </p>
      <div className="d-flex justify-content-center">
        <hr className="w-25 dynamic-hr" />
      </div>
      <p className="mb-0">{club.subtitle.substring(0, 120)}</p>
      <div className="d-flex justify-content-center">
        <hr className="w-25 dynamic-hr" />
      </div>
    </div>
  </div>

  <div className="d-flex align-items-center justify-content-center pointer mt-auto">
    {[...Array(5)].map((_, index) => {
      if (index < fullStars) return <StarFill key={index} />;
      if (index === fullStars && hasHalfStar) return <StarHalf key={index} />;
      return <Star key={index} />;
    })}
    <p className="mx-2 mt-4">
      {starsAverage.toFixed(1)} • {totalReviews} reviews
    </p>


 
  </div>

<p>{Math.round(club.distance)}km away</p>
</div>

    );
  };

  if (isloading) {
    return <LoadingSpinner />;
  } else {
    return (
      <div className="container">
     
        <div className="d-flex searchbar">
          <input
            type="text"
            className="form-control py-3 dynamic-input"
            placeholder="Search for the club"
            onChange={(e) => {
              setName(e.target.value);
              setSkip(0);
              setTake(24);
            }}
            value={name}
          />
          <div className="search-icon-holder" onClick={fetchData}>
            <span>
              <Search color="white" size={24} className="mx-3 mt-3" />
            </span>
          </div>
        </div>

        <div className="row">
          {clubs.map((club) => renderClubCard(club))}
        </div>

        {clubs.length === 0 && (
          <p className="text-center">No clubs found.</p>
        )}

        <div className="d-flex justify-content-center my-3">
          <ArrowLeftCircle
            size={50}
            onClick={handlePrev}
            className={`${skip === 0 ? "opacity-50" : "pointer"} mx-5`}
          />
          <ArrowRightCircle
            size={50}
            onClick={handleNext}
            className={`${
              parseInt(clubs.length) < parseInt(take)
                ? "opacity-50"
                : "pointer"
            }`}
          />
        </div>
      </div>
    );
  }
}
